/**
 * All event listeners
 * */

// Load pixel event
jQuery(document).on("wpmLoadPixels", function () {

	if (wpmDataLayer?.pixels?.facebook?.pixel_id && !wpmDataLayer?.pixels?.facebook?.loaded) {
		if (wpm.canIFire("ads", "facebook-ads")) wpm.loadFacebookPixel()
	}
})

// AddToCart event
jQuery(document).on("wpmAddToCart", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		let eventId = wpm.getRandomEventId()

		// console.log('eventId: ' + eventId);

		fbq("track", "AddToCart", {
			content_type: "product",
			content_name: product.name,
			content_ids : product.dyn_r_ids[wpmDataLayer.pixels.facebook.dynamic_remarketing.id_type],
			value       : parseFloat(product.quantity * product.price),
			currency    : product.currency,
		}, {
			eventID: eventId,
		})


		product["currency"] = wpmDataLayer.shop.currency

		jQuery(document).trigger("wpmFbCapiEvent", {
			event_name      : "AddToCart",
			event_id        : eventId,
			user_data       : wpm.getFbUserData(),
			product_data    : product,
			product_id      : product.dyn_r_ids[wpmDataLayer.pixels.facebook.dynamic_remarketing.id_type],
			event_source_url: window.location.href,
		})
	} catch (e) {
		console.error(e)
	}
})

// InitiateCheckout event
jQuery(document).on("wpmBeginCheckout", function (event) {

	try {
		// console.log('firing facebook ads InitiateCheckout event');

		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		let eventId = wpm.getRandomEventId()

		fbq("track", "InitiateCheckout", {}, {
			eventID: eventId,
		})

		jQuery(document).trigger("wpmFbCapiEvent", {
			event_name      : "InitiateCheckout",
			event_id        : eventId,
			user_data       : wpm.getFbUserData(),
			event_source_url: window.location.href,
		})
	} catch (e) {
		console.error(e)
	}
})

// AddToWishlist event
jQuery(document).on("wpmAddToWishlist", function (event, product) {

	try {
		// console.log('firing facebook ads AddToWishlist event');
		// console.log(product);

		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		let eventId = wpm.getRandomEventId()

		fbq("track", "AddToWishlist", {
			content_type: "product",
			content_name: product.name,
			content_ids : product.dyn_r_ids[wpmDataLayer.pixels.facebook.dynamic_remarketing.id_type],
			value       : parseFloat(product.quantity * product.price),
			currency    : product.currency,
		}, {
			eventID: eventId,
		})


		product["currency"] = wpmDataLayer.shop.currency

		jQuery(document).trigger("wpmFbCapiEvent", {
			event_name      : "AddToWishlist",
			event_id        : eventId,
			user_data       : wpm.getFbUserData(),
			product_data    : product,
			product_id      : product.dyn_r_ids[wpmDataLayer.pixels.facebook.dynamic_remarketing.id_type],
			event_source_url: window.location.href,
		})
	} catch (e) {
		console.error(e)
	}
})

// ViewContent event
jQuery(document).on("wpmViewItem", function (event, product) {

	try {
		// console.log('firing facebook ads ViewContent event');
		// console.log(product);

		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		wpm.fbViewContent(product)
	} catch (e) {
		console.error(e)
	}
})

// view search event
jQuery(document).on("wpmSearch", function () {

	try {
		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		let eventId = wpm.getRandomEventId()

		fbq("track", "Search", {}, {
			eventID: eventId,
		})

		jQuery(document).trigger("wpmFbCapiEvent", {
			event_name      : "Search",
			event_id        : eventId,
			user_data       : wpm.getFbUserData(),
			event_source_url: window.location.href,
		})
	} catch (e) {
		console.error(e)
	}
})

// load always event
jQuery(document).on("wpmLoadAlways", function () {

	try {
		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		wpm.setFbUserData()
	} catch (e) {
		console.error(e)
	}
})

// view order received page event
// https://developers.pinterest.com/docs/tag/conversion/
jQuery(document).on("wpmOrderReceivedPage", function () {

	try {
		if (!wpmDataLayer?.pixels?.facebook?.loaded) return

		fbq("track", "Purchase",
			{
				content_type: "product",
				value       : wpmDataLayer.order.value_filtered,
				currency    : wpmDataLayer.order.currency,
				content_ids : wpm.facebookContentIds(),
			},
			{eventID: wpmDataLayer.order.id},
		)


		// console.log(wpm.facebookContentIds())
	} catch (e) {
		console.error(e)
	}
})
